import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VehiclesRoutingModule } from './vehicles-routing.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromVehicles from './+state/vehicles.reducer';
import { VehiclesEffects } from './+state/vehicles.effects';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreUiModule } from '@pos-app/core-ui';
import { NgSelectModule} from '@ng-select/ng-select';
import { MatChipsModule as MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import {MatAutocompleteModule as MatAutocompleteModule} from '@angular/material/autocomplete';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { VehiclesSelectionComponent } from './components/vehicles-selection/vehicles-selection.component';
import { VehicleDetailsComponent } from './components/vehicle-details/vehicle-details.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        VehiclesRoutingModule,
        CoreUiModule,
        NgSelectModule,
        MatChipsModule,
        MatIconModule,
        MatInputModule,
        MatAutocompleteModule,
        NgbModule,
        StoreModule.forFeature(fromVehicles.VEHICLES_FEATURE_KEY, fromVehicles.reducer),
        EffectsModule.forFeature([VehiclesEffects])
        , VehiclesSelectionComponent, VehicleDetailsComponent
    ],
    exports: [VehiclesSelectionComponent, VehicleDetailsComponent]
    
})
export class VehiclesModule {}


